/* eslint-disable react/prop-types */
import { FC } from 'react'
import styles from './Button.module.css'

interface ButtonProps {
  type?: string
  color?: string
  children?: React.ReactNode
  className?: string
  onClick?: () => void
}

const Button: FC<ButtonProps> = ({
  type,
  color,
  children,
  className,
  onClick,
  ...props
}) => {
  const buttonClassName = `${styles.button} ${
    type === 'group-pages-item' ? styles.groupPagesItem : ''
  } ${className || ''}`

  const style =
    type === 'group-pages-item' && color
      ? ({ '--button-color': `var(${color})` } as React.CSSProperties)
      : {}

  return (
    <button
      className={buttonClassName}
      onClick={onClick}
      style={style}
      {...props}
    >
      {children}
    </button>
  )
}

export default Button
